import { isCellphoneNumber, fixDDDonMask } from "../../helpers/commonHelpers";
import {
    documentPatterns,
    phonePatterns,
    datePatterns
} from "../../helpers/patterns";
import Cleave from "cleave.js";

const initializePhoneFields = () => {
    const phoneFields          = $(".js-cleave-phone");
    const { mobile, landline } = phonePatterns;

    phoneFields.each(function () {
        const field = $(this);

        field.mask(isCellphoneNumber(field.val() || "") ? mobile : landline, {
            onChange: (value, e, $field, options) => {
                const numberDDDFixed = fixDDDonMask($field, { mobile, landline });

                // Change the mask in each stroke so that the pattern changes when needed, instead of only landline to mobile.
                $field.mask(isCellphoneNumber(numberDDDFixed || value) ? mobile : landline, options);
            }
        });

        field.on('input', function () {
            $(field).trigger('change');
        });
    });
};

const initializeLandlineFields = () => {
    const landlinePhoneNumberFields = $(".js-cleave-landline");
    const { landline, mobile }      = phonePatterns;

    landlinePhoneNumberFields.each(function () {
        const $field = $(this);

        $field.mask(landline, {
            onChange: (value, e, $field) => {
                fixDDDonMask($field, { mobile, landline });
            }
        });
    });
};

const initializeCpfCnpjFields = () => {
    const cpfCnpjFields                   = $(".js-cleave-cpf-cnpj");
    const { cpf, cnpj, cnpjAlfanumerico } = documentPatterns;

    let cnpjMask = cnpj;

    if (window.enabledAlfanumericCnpj) {
        cnpjMask = cnpjAlfanumerico;
    }

    cpfCnpjFields.each(function () {
        const field = $(this);

        field.on("input", function () {
            const value  = field.val();
            const isCnpj = value.length >= 14 || /[a-zA-Z]/.test(value);

            isCnpj ? field.mask(cnpjMask) : field.mask(cpf);
        });

    });
};

const initializeCpfFields = () => {
    const cpfFields = $(".js-cleave-cpf");
    const { cpf }   = documentPatterns;

    cpfFields.each(function () {
        const field = $(this);

        field.on("input", function () {
            field.mask(cpf);
        });

    });
};

const initializeCnpjFields = () => {
    const cnpjFields                 = $(".js-cleave-cnpj");
    const { cnpj, cnpjAlfanumerico } = documentPatterns;

    let cnpjMask = cnpj;

    if (window.enabledAlfanumericCnpj) {
        cnpjMask = cnpjAlfanumerico;
    }

    cnpjFields.each(function () {
        const field = $(this);

        field.on("input", function () {
            field.mask(cnpjMask);
        });

    });
};

const initializeDateFields = () => {
    const dateFields = $(".js-cleave-date");
    const { date }   = datePatterns;

    dateFields.each(function () {
        const field = $(this);

        field.on("input", function () {
            field.mask(date);
        });

    });
};

const initializeCepFields = () => {
    const cepFields = $(".js-cleave-cep");
    const { cep }   = documentPatterns;

    cepFields.each(function () {
        const field = $(this);

        field.on("input", function () {
            field.mask(cep);
            const value = field.val();

            if (value && value.length === cep.length) {
                field.trigger("change");
            }
        });
    });
};

const initializeNumberOnlyFields = () => {
    const $numberOnlyFields = $(".js-cleave-number-only");

    $numberOnlyFields.each(function () {
        const $field    = $(this);
        const maxLength =  $field.attr("maxlength");

        new Cleave($field, {
            blocks: [maxLength ? maxLength : Infinity],
            numericOnly: true,
        });
    });
};

const initializeNumberOrXFields = () => {
    const $numberOrXFields = $(".js-cleave-number-or-x");

    $numberOrXFields.each(function () {
        const $field    = $(this);
        const maxLength =  $field.attr("maxlength");

        new Cleave($field, {
            blocks: [maxLength ? maxLength : Infinity],
            prefix: '',
            delimiter: '',
            numericOnly: false,
            uppercase: true,
            onValueChanged: function (e) {
                const value = e.target.value;
                if (!/^[0-9xX]*$/.test(value)) {
                    $field.val('');
                }
            }
        });
    });
};

const initializeMaskFields = () => {
    initializePhoneFields();
    initializeLandlineFields();
    initializeCpfCnpjFields();
    initializeCpfFields();
    initializeCnpjFields();
    initializeDateFields();
    initializeCepFields();
    initializeNumberOnlyFields();
    initializeNumberOrXFields();
};

export default initializeMaskFields;
